import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { DeleteForeverOutlined } from '@mui/icons-material';
import { Url } from '../services/Constants';
import { setHeader } from '../services/Headers';
import { removeFavorite } from '../redux/action';
import { useDispatch } from "react-redux";

export default function FavoriteProductTile() {
  const [favoriteProducts, setFavoriteProducts] = useState([]);
  const dispatch = useDispatch();

  // Get favorite products
  useEffect(() => {
    const fetchFavoriteProducts = async () => {
      try {
        const response = await axios.get(`${Url}/buyer/products/favourite_products`, setHeader());
        const products = response.data.response_data.products;
        setFavoriteProducts(products);
      } catch (error) {
        console.error('Error fetching favorite products:', error);
      }
    };

    fetchFavoriteProducts();
  }, []);

  // Handle remove favorite
  const handleRemoveFavorite = async (productId) => {
    try {
      await axios.post(
        `${Url}/buyer/products/${productId}/favourite_unfavourite?is_favourite=false`,
        {},
        setHeader()
      );
      dispatch(removeFavorite(productId));
      setFavoriteProducts((prevProducts) =>
        prevProducts.filter((product) => product.id !== productId)
      );
    } catch (error) {
      console.error('Error removing favorite product:', error);
    }
  };

  return (
    <div className="favorite-products p-4 md:p-6">
      {favoriteProducts.length > 0 ? (
        favoriteProducts.map((product) => (
          <div
            key={product.id}
            className="products bg-white shadow-2xl rounded-2xl mb-4 flex flex-col md:flex-row md:h-48"
          >
            <div className="left flex cursor-pointer group">
              <img
                src={product.product_images[0]?.image || 'assets/placeholder.png'}
                alt={product.name}
                className="w-full h-full object-cover group-hover:opacity-50 md:h-full"
              />
            </div>
            <div className="right mx-0 md:mx-2 w-full md:w-[75%] p-2">
              <div className="product-name flex justify-between items-center text-amber-950 text-lg md:text-2xl font-bold cursor-pointer">
                <span>{product.name}</span>
                <DeleteForeverOutlined
                  fontSize="large"
                  className="relative bottom-1 w-auto h-auto left-4 p-1 cursor-pointer rounded-full hover:text-red-600 text-amber-950"
                  onClick={() => handleRemoveFavorite(product.id)}
                />
              </div>
              <div className="product-specification text-sm md:text-base text-amber-950 cursor-default">
                {product.specification}
              </div>
              <div className="product-bottom mt-3 flex flex-col md:flex-row justify-between items-end">
                <div className="price-container w-full md:w-1/2">
                  <div className="price">
                    <span className="text-amber-950 font-bold text-lg">
                      Rs. {product.product_variants[0]?.discounted_price || 'N/A'}{' '}
                    </span>
                    <span className="text-amber-950 text-sm">
                      ( GST - {product.gst}% )
                    </span>
                  </div>
                </div>
                <div className="product-buttons w-full md:w-1/2 mt-2 md:mt-0">
                  <div className="right-button flex justify-between">
                    <div className="add-cart bg-amber-950 rounded-md px-4 py-2 text-center text-white hover:bg-amber-900 cursor-pointer w-full md:w-auto">
                      Add To Cart
                    </div>
                    <div className="buy-now ml-2 bg-amber-950 rounded-md px-4 py-2 text-center text-white hover:bg-amber-900 cursor-pointer w-full md:w-auto">
                      Buy Now
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="text-center h-dvh text-amber-950">No favorite products found.</div>
      )}
    </div>
  );
}